// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1TFz5","importantInfo":"styles_importantInfo__If2TB"};